'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Switch, Route, Redirect, useParams } from 'react-router-dom';
import ErrorPage from '../components/pages/ErrorPage';
import HomePage from '../components/pages/HomePage';
import ResultsPage from '../components/pages/ResultsPage';
import WidgetErrorPage from '../components/pages/WidgetErrorPage';
import WidgetResultsPage from '../components/pages/WidgetResultsPage';
import InputUtil from '../util/InputUtil';
import { ThemeProvider } from '../theming/ThemeProvider.js';
import { TESTS, ERROR, ROOT } from '../constants/Paths';

const getSanitizedHostname = websiteUrl => InputUtil.parseWebsiteUrl(decodeURIComponent(websiteUrl));

const ProtectedResultsPage = () => {
  const {
    websiteUrl
  } = useParams();
  const hostname = getSanitizedHostname(websiteUrl);
  return hostname === websiteUrl ? /*#__PURE__*/_jsx(ResultsPage, {}) : null;
};

export default (() => /*#__PURE__*/_jsx(ThemeProvider, {
  children: /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: `/widget${TESTS}/:websiteUrl`,
      component: WidgetResultsPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `/widget${ERROR}/:errorType?`,
      component: WidgetErrorPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${TESTS}/:websiteUrl`,
      component: ProtectedResultsPage
    }), /*#__PURE__*/_jsx(Route, {
      path: `${ERROR}/:errorType?`,
      component: ErrorPage
    }), /*#__PURE__*/_jsx(Route, {
      path: ROOT,
      exact: true,
      component: HomePage
    }), /*#__PURE__*/_jsx(Redirect, {
      to: ROOT
    })]
  })
}));